import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import UserService from '../services/UserService';
import NotificationService from '../services/NotificationService';

const initialState = {
  datas: [],
  dataLoading: false,
  submitLoading: false,
  pagination: {
    page: null,
    perPage: null,
    total: null,
  },
  hasMore: false,
  notiStats: null,
  notiCount: 0
};

export const fetchNotificationList = createAsyncThunk(
  'notification/fetchNotification',
  async ({ perPage, page, keyword }) => {
    try {
      const resp = await NotificationService.fetchNotification({ perPage, page, keyword });
      return resp;
    } catch (e) {
      return e.response;
    }
  },
);

export const saveFCMToken = createAsyncThunk(
  'user/saveFCMToken',
  async (data, { rejectWithValue }) => {
    try {
      const resp = await UserService.saveFCMToken(data);
      return resp;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const fetchNotificationStats = createAsyncThunk(
  'notification/fetchNotificationStats',
  async () => {
    try {
      const resp = await NotificationService.fetchNotificationStats();
      return resp;
    } catch (e) {
      return e.response;
    }
  },
);

const notificationSlice = createSlice({
  name: 'notification',
  initialState: initialState,
  reducers: {
    notificationReceived: (state) => {
      console.log('notificationReceived reducer called');
      
      // Make sure notiStats exists
      if (!state.notiStats) {
        state.notiStats = {
          unread_count: 1,
          total_count: 1,
        };
      } else {
        // Increment unread_count
        state.notiStats.unread_count = (state.notiStats.unread_count || 0) + 1;
        
        // Also increment total_count if it exists
        if (state.notiStats.total_count !== undefined) {
          state.notiStats.total_count += 1;
        }
      }
      
      console.log('Updated unread count:', state.notiStats.unread_count);
    },
    addNewNotification: (state, action) => {
      // Add the new notification to the beginning of the list
      state.datas.unshift(action.payload);
    } 
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotificationList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchNotificationList.fulfilled, (state, action) => {
        state.datas = [...action.payload?.data.data?.notifications];
        state.pagination = action.payload?.data.data?.pagination;
        state.loading = false;
      })
      .addCase(fetchNotificationList.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.loading = false;
      })
      .addCase(saveFCMToken.pending, (state, action) => {})
      .addCase(saveFCMToken.fulfilled, (state, action) => {})
      .addCase(saveFCMToken.rejected, (state, action) => {})
      .addCase(fetchNotificationStats.pending, (state, action) => {
      })
      .addCase(fetchNotificationStats.fulfilled, (state, action) => {
        state.notiStats = action.payload?.data.data;
      })
      .addCase(fetchNotificationStats.rejected, (state, action) => {});;
  },
});

const { reducer } = notificationSlice;

export const { notificationReceived, addNewNotification } = notificationSlice.actions;

export const notificationSelector = (state) => state?.notification;

export default reducer;
